import { AuditableStatus } from '../enums';

export interface ICommentOutputDto {
    id?: string;
    comment: string;
    createdBy: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface IAuditableOutputDto {
    status: AuditableStatus;
    comments?: ICommentOutputDto[];
    resolvedAt?: string;
    resolvedBy?: string;
    createdBy: string;
}
